// extracted by mini-css-extract-plugin
export default {"toolbar":"BuilderBanner_toolbar__AkOsQ"};